import React from "react";
import Accordion from "react-bootstrap/Accordion"

import './Project.css'

function TechStack() {
    return (
        <>
            <Accordion>
                <Accordion.Item eventKey="0">
                    <Accordion.Header>
                        <h4 className="accordian-header"> Used Stack & Tools </h4>
                    </Accordion.Header>
                    <Accordion.Body className="accordian-text">
                        <p id="tech-up-text" className="top-text">※ We've collected only the technology stacks and tools used in at least two projects.</p>
                        <p id="tech-text" className="top-text">※ Among the technology stacks, C, C++, and C# are interpretable, but they haven't been used enough to be directly applicable to projects. It may take some time to adapt.</p>
                        <h5 className="tech-text"> Technology Stack - Languages </h5>
                        <div className="badges_container">
                            <div className="badges">
                                <img class="badge1" src="https://img.shields.io/badge/Python-3776AB?style=flat-square&logo=Python&logoColor=white" />
                                <img class="badge1" src="https://img.shields.io/badge/R-276DC3?style=flat-square&logo=R&logoColor=white" />
                                <img class="badge1" src="https://img.shields.io/badge/SQL-276DC3?style=flat-square&logo=MySQL&logoColor=white" />
                                <br></br>
                                <img class="badge1" src="https://img.shields.io/badge/Java-007396?style=flat-square&logo=openjdk&logoColor=white" />
                                <img class="badge1" src="https://img.shields.io/badge/Kotlin-0095D5?style=flat-square&logo=Kotlin&logoColor=white" />
                                <br></br>
                                <img class="badge1" src="https://img.shields.io/badge/Javascript-F7DF1E?style=flat-square&logo=Javascript&logoColor=white" />
                                <img class="badge1" src="https://img.shields.io/badge/Typescript-3178C6?style=flat-square&logo=Typescript&logoColor=white" />
                                <br></br>
                                <img class="badge1" src="https://img.shields.io/badge/html5-E34F26?style=flat-square&logo=HTML5&logoColor=white" />
                                <img class="badge1" src="https://img.shields.io/badge/CSS3-1572B6?style=flat-square&logo=CSS3&logoColor=white" />
                                <img class="badge1" src="https://img.shields.io/badge/Markdown-000000?style=flat-square&logo=markdown&logoColor=white" />
                                <br></br>
                                <img class="badge1" src="https://img.shields.io/badge/Abap-0FAAFF?style=flat-square&logo=SAP&logoColor=white" />
                                <br></br>
                            </div>
                        </div>
                        <br></br>
                        <hr></hr>
                        <h5 className="tech-text"> Technology Stack - Frameworks and Libraries </h5>
                        <div className="badges_container">
                            <div className="badges">
                                <img class="badge1" src="https://img.shields.io/badge/Express-000000?style=flat-square&logo=Express&logoColor=white" />
                                <img class="badge1" src="https://img.shields.io/badge/SpringBoot-6DB33F?style=flat-square&logo=Spring&logoColor=white" />
                                <br></br>
                                <img class="badge1" src="https://img.shields.io/badge/React-61DAFB?style=flat-square&logo=React&logoColor=black" />
                                <img class="badge1" src="https://img.shields.io/badge/Bootstrap-563D7C?style=flat-square&logo=bootstrap&logoColor=white" />
                                <br></br>
                                <img class="badge1" src="https://img.shields.io/badge/pandas-150458?style=flat-square&logo=pandas&logoColor=white" />
                                <img class="badge1" src="https://img.shields.io/badge/numpy-013243?style=flat-square&logo=NumPy&logoColor=white" />
                                <img class="badge1" src="https://img.shields.io/badge/scikit_learn-F7931E?style=flat-square&logo=scikit-learn&logoColor=black" />
                            </div>
                        </div>
                        <br></br>
                        <hr></hr>
                        <h5 className="tech-text"> Technology Stack - Databases </h5>
                        <div className="badges_container">
                            <div className="badges">
                                <img class="badge1" src="https://img.shields.io/badge/MySQL-00000F?style=flat-square&logo=mysql&logoColor=white" />
                                <img class="badge1" src="https://img.shields.io/badge/MariaDB-003545?style=flat-square&logo=mariadb&logoColor=white" />
                                <img class="badge1" src="https://img.shields.io/badge/Oracle-F80000?style=flat-square&logo=Oracle&logoColor=white" />
                            </div>
                        </div>
                        <br></br>
                        <hr></hr>
                        <h5 className="tech-text"> Technology Stack - Cloud </h5>
                        <div className="badges_container">
                            <div className="badges">
                                <img class="badge1" src="https://img.shields.io/badge/Amazon_AWS-FF9900?style=flat-square&logo=amazonaws&logoColor=white" />
                                <img class="badge1" src="https://img.shields.io/badge/Google_Cloud-4285F4?style=flat-square&logo=google-cloud&logoColor=white" />
                                <img class="badge1" src="https://img.shields.io/badge/Vercel-000000?style=flat-square&logo=vercel&logoColor=white" />
                            </div>
                            <div className="top-text">
                                AWS has a wide range of solutions, so if we list a few more in detail,<br></br>
                                1. RDS <br></br>
                                2. EC2 <br></br>
                                3. S3 <br></br>
                                These are the ones we've used, and we have a basic understanding of other solutions as well, acquired while obtaining SAA certification.
                            </div>
                        </div>
                        <br></br>
                        <hr></hr>
                        <h5 className="tech-text"> Social </h5>
                        <div className="badges_container">
                            <div className="badges">
                                <img class="badge1" src="https://img.shields.io/badge/GitHub-100000?style=flat-square&logo=github&logoColor=white" />
                                <img class="badge1" src="https://img.shields.io/badge/GitLab-330F63?style=flat-square&logo=gitlab&logoColor=white" />
                            </div>
                        </div>
                        <br></br>
                        <hr></hr>
                        <h5 className="tech-text"> Tools </h5>
                        <div className="badges_container">
                            <div className="badges">
                                <h6>IDE</h6>
                                <img class="badge1" src="https://img.shields.io/badge/Android Studio-3DDC84?style=flat-square&logo=AndroidStudio&logoColor=white" />
                                <img class="badge1" src="https://img.shields.io/badge/R Studio-75AADB?style=flat-square&logo=RStudio&logoColor=white" />
                                <img class="badge1" src="https://img.shields.io/badge/Colab-F9AB00?style=flat-square&logo=googlecolab&color=525252" />
                                <img class="badge1" src="https://img.shields.io/badge/Eclipse-2C2255?style=flat-square&logo=eclipse&logoColor=white" />
                                <img class="badge1" src="https://img.shields.io/badge/IntelliJ_IDEA-000000.svg?style=flat-square&logo=intellij-idea&logoColor=white" />
                                <img class="badge1" src="https://img.shields.io/badge/Visual_Studio_Code-0078D4?style=flat-square&logo=visual%20studio%20code&logoColor=white" />
                                <br></br>
                                <h6>Design</h6>
                                <img class="badge1" src="https://img.shields.io/badge/Figma-F24E1E?style=flat-square&logo=figma&logoColor=white" />
                                <img class="badge1" src="https://img.shields.io/badge/blender-%23F5792A.svg?style=flat-square&logo=blender&logoColor=white" />
                                <br></br>
                                <h6>OA & ETC</h6>
                                <img class="badge1" src="https://img.shields.io/badge/Microsoft_Office-D83B01?style=flat-square&logo=microsoft-office&logoColor=white" />
                                <img class="badge1" src="https://img.shields.io/badge/Microsoft_Access-A4373A?style=flat-square&logo=microsoft-access&logoColor=white" />
                                <img class="badge1" src="https://img.shields.io/badge/Google%20Sheets-34A853?style=flat-square&logo=google-sheets&logoColor=white" />
                                <img class="badge1" src="https://img.shields.io/badge/Notion-000000?style=flat-square&logo=notion&logoColor=white" />
                                <img class="badge1" src="https://img.shields.io/badge/Trello-0052CC?style=flat-square&logo=trello&logoColor=white" />
                            </div>
                        </div>
                        <br></br>

                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </>
    )
}

export default TechStack;
